import SearchResult from "./search-result"

export default SearchResult
